<template>
  <div class="driver-wallet main">
    <div class="wrapper">
      <div class="update-btn">
        <i v-if="updating" class="fa fa-atom fa-spin" />
        <i v-else class="fa fa-redo" @click="getHistory" />
      </div>
      <div class="is-size-4 has-text-light">
        <p style="margin-bottom: 6px">
          <span @click="close">
            <i class="fa fa-chevron-left" style="margin-right: 4px" />
            {{ $t("driver.driver-wallet") }}
          </span>
        </p>
      </div>

      <div class="date-list no-scrollbar">
        <div v-if="showHistory">
          <div v-if="driverBonusData" class="totals">
            <div class="is-flex" @click="toggleLastNDays">
              <div v-if="showNDaysCount === 30">
                <div class="goal">
                  {{ countLast30Days }}
                </div>
                <div class="this" style="width: auto">
                  {{ $t("driver.job-count-last-30") }}
                </div>
              </div>
              <div v-if="showNDaysCount === 7">
                <div class="goal">{{ countLast7Days }}</div>
                <div class="this" style="width: auto">
                  {{ $t("driver.job-count-last-7") }}
                </div>
              </div>
            </div>
          </div>
          <div class="totals" @click="periodToggle = !periodToggle">
            <div class="date-flex">
              <div class="this" v-html="shortPeriodTitle" />
              <div class="total-earnings">฿{{ shortPeriodEarnings }}</div>
              <div class="this" v-html="longPeriodTitle" />
              <div class="total-earnings">{{ longPeriodEarnings }}</div>
            </div>
          </div>

          <div v-for="i in 9" :key="i" class="date-item" @click="selectDate(i)" v-ripple>
            <div class="date-flex">
              <div class="date">{{ daysAgo(i - 1) }}</div>
              <div class="earnings">฿{{ dailyEarnings(i) }}</div>
              <div class="njobs">
                {{ dailyJobs(i - 1) }} {{ $t("profile.jobs") }}
              </div>
              <div class="bonus-achieved">
                <!-- <i class="fa fa-check-circle" /> -->
                <i :class="remitClass(i - 1)" />
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="dayIdx">
          <div class="date-item">
            <div class="selected-date" @click="clearDate">
              <div style="display: inline-block">
                <!-- <i class="fa fa-chevron-left" />&nbsp; -->
                {{ daysAgo(realIdx) }}
              </div>
              <div class="is-pulled-right" style="color: rgb(238, 252, 81)">
                {{ $t("total") }} ฿{{ dailyEarnings(dayIdx) }}
              </div>
            </div>

            <div class="date-flex">
              <div class="earnings">
                <span>{{ $t("cash") }}</span>
                ฿{{ dailyEarnings(dayIdx, "cash") }}
              </div>
              <div class="njobs">
                <span>TukPay</span>
                ฿{{ dailyEarnings(dayIdx, "tukpay") }}
              </div>
            </div>
            <div class="remit" :class="{ pulse: remitState === 'ready' }" @click="openTransferRemit">
              <span>{{ $t("remit") }} </span>

              <!-- <b v-if="dailyEarnings(dayIdx, 'remit') > 0"> -->
              <b v-if="remitTransaction">
                <b v-if="remitState === 'initiated'" class="button is-small is-dark has-text-grey">{{
                  $t("driver.transfer-later") }}&nbsp;
                  <i class="far fa-hourglass fa-sm" />
                </b>
                <b v-if="remitState === 'ready'" class="button is-small is-warning">{{ $t("driver.transfer-now") }}&nbsp;
                  <i class="fa fa-file-image" />
                </b>
                <b v-if="remitState === 'pending'" class="button is-small is-link">{{ $t("payment.transfer-pending")
                }}&nbsp;
                  <i class="fa fa-spinner fa-spin fa-sm" />
                </b>
                <b v-if="remitState === 'completed'" class="button is-small is-warning">{{
                  $t("payment.transfer-completed") }}&nbsp;
                  <i class="fa fa-check fa-sm" />
                </b>
              </b>
              <b v-else class="button is-small is-dark has-text-grey">
                <i class="fa fa-cog fa-spin fa-sm" />
              </b>
              <!-- </b> -->

              <!-- ฿{{ dailyEarnings(dayIdx, "remit") }} -->
            </div>
          </div>

          <div class="transaction" v-for="t in daysJobs(realIdx)" :key="t.id" @click="selectTransaction(t)">
            <div class="time">{{ shortTime(t) }}</div>
            <div v-if="earnings(t)" class="txn-total">฿{{ earnings(t) }}</div>
            <div class="pickup">
              {{ t.data.pickup_stop.name || $t("ride.pin-location") }}
            </div>
          </div>
        </div>

        <div v-else>
          <p v-if="updating" class="spinner">
            <i class="fa fa-cog fa-spin fa-10x" />
          </p>
          <p v-else class="notification is-warning">
            {{ $t("driver.history-will-appear-here") }}
          </p>
        </div>
      </div>

      <span class="bottom-left">
        <span class="transfer" @click="showSettings = true">
          <i class="fa fa-cog" />
        </span>

        <span class="transfer" @click="showQRCode = true">
          <i class="fa fa-qrcode" />
          <!-- <i class="fa fa-university" /> -->
        </span>
        <span class="transfer" @click="showInvite = true">
          <i class="fa fa-share-alt" />
        </span>
      </span>

      <span class="mobile" @click="loginInfo">
        {{ $store.getters.phoneNumber
        }}<b class="has-text-warning">{{ loginMethod }}</b>
      </span>
    </div>

    <DriverWalletTransaction v-if="selectedTransaction" :t="selectedTransaction" @close="selectedTransaction = null"
      @closeWallet="closeWallet" />

    <DriverWalletQRCode v-if="showQRCode" :driverID="driverID" @close="showQRCode = false" />

    <DriverWalletInvite v-if="showInvite" @close="showInvite = false" />

    <driverWalletSettings v-if="showSettings" @close="showSettings = false" />

    <DriverRemitPayment v-if="showDriverRemitPayment" :t="remitTransaction" @update="getRemitTransactionForDate"
      @close="showDriverRemitPayment = false" />
  </div>
</template>

<script>
import EventBus from "../eventBus";

import DriverWalletTransaction from "@/components/DriverWalletTransaction.vue";
import DriverWalletQRCode from "@/components/DriverWalletQRCode.vue";
import DriverWalletInvite from "@/components/DriverWalletInvite.vue";
import DriverWalletSettings from "@/components/DriverWalletSettings.vue";
import DriverRemitPayment from "@/components/DriverRemitPayment.vue";

export default {
  name: "DriverWallet",
  props: {
    remitTransactions: Array, // null if superuser viewing wallet
    missingPaymentInfo: Boolean,
    driverID: String, // set if coming from driver_wallet
  },
  components: {
    DriverWalletTransaction,
    DriverWalletQRCode,
    DriverWalletInvite,
    DriverWalletSettings,
    DriverRemitPayment,
  },
  data() {
    return {
      superRemitTransactions: null, // set if super user viewing wallet
      showDriverRemitPayment: false,
      remitTransaction: null,
      dayIdx: 0, // start from 1...
      history: [],
      showNDaysCount: 30,
      countLast30Days: null,
      countLast7Days: null,
      driverBonusData: null, //
      updating: false,
      periodToggle: false, // toggles between `this week` and `last 7 days`
      selectedTransaction: null,
      showQRCode: false,
      showInvite: false,
      showSettings: false,
    };
  },
  watch: {
    dayIdx: function (idx) {
      if (idx == 0) return; // means no date selected
      this.getRemitTransactionForDate();
    },
  },
  computed: {
    role() {
      return this.$store.getters.getDriverRole;
    },
    remitState() {
      if (!this.remitTransaction) return null;
      return this.remitTransaction.state;
    },
    loginMethod() {
      var str = this.$store.state.loginMethod;
      if (!str) return "U";
      return str[0].toUpperCase();
    },
    realIdx() {
      return this.dayIdx - 1;
    },
    showHistory() {
      return this.history.length && !this.dayIdx;
    },
    shortPeriodTitle() {
      if (this.periodToggle) return "7<br>" + this.$t("days");
      return this.$t("driver.this-week");
    },
    longPeriodTitle() {
      if (this.periodToggle) return "30<br>" + this.$t("days");
      return this.$t("driver.this-month");
    },
    shortPeriodEarnings() {
      var total = 0;
      for (var i = 0; i < 7; i++) {
        total += this.dailyEarnings(i);
      }
      return total;
    },
    longPeriodEarnings() {
      return `🥳`;
    },
    remits() {
      return this.remitTransactions || this.superRemitTransactions;
    },
    hasUnpaidRemits() {
      if (!this.remits) return;
      return this.remits.find((r) => r.state === "ready");
    }
  },
  mounted() {
    this.getHistory();
    this.getDriverWalletData();
    if (this.missingPaymentInfo) this.showQRCode = true;
    if (this.remitTransactions) this.checkRemitTransactions();
    // else this.getRemitTransactions(); // if superuser coming directly to wallet
    else this.checkDriverRemit();
  },
  methods: {
    closeWallet() {
      this.selectedTransaction = null;
      this.close();
    },
    checkPromptRemit() {
      if (!this.hasUnpaidRemits) return; // everything is paid, skip
      // var msg = `💲 Remit check [${this.$store.getters.realName}]`;
      // this.sendSuperuserNotification(msg);
      // if driver hasn't paid remits
      var title = `การแจ้งเตือนการชำระเงินบัญชีคนขับ` // Driver Account Payment Reminder
      var txt1 = `อย่าลืมโอนชำระทุกวันหลัง` // Remember to transfer payment after each day.
      var txt2 = `ติดต่อ LINE ID <b>minttuk</b> หากคุณต้องการความช่วยเหลือ` // Contact LINE ID <b>minttuk</b> if you need help.
      this.$swal({
        html: `<div style='text-align:left;'>
          <p style='margin-bottom:12px; font-size:1.1em'>
            <i class='fa fa-question-circle'></i>&nbsp;
            ${title}
          </p>
          <p style='margin-bottom:10px'>${txt1}</p>
          <p>${txt2}</p>
          </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: `LINE ID <b>minttuk</b> <i class='fa fa-chevron-right'></i>`,
        confirmButtonColor: this.bulmaColor("success")
      }).then((val) => {
        if (val.value) {
          var driverLINESupportURL = `https://line.me/ti/p/~minttuk`
          window.open(driverLINESupportURL, "_blank")
        }
      })

    },
    close() {
      if (this.dayIdx) {
        this.clearDate();
        this.checkPromptRemit();
        return;
      }
      if (this.driverID) {
        // this.goBack();
        this.$router.go(-1); // go back
        return;
      }
      this.updateTransactionsForDriver(true);
      this.$emit("close");
    },
    checkDriverRemit() {
      this.$store
        .dispatch("getRecentDriverRemitTransactions", this.driverID)
        .then((res) => {
          console.log("getRecentDriverRemit", res.data);
          this.superRemitTransactions = res.data || [];
        })
        .catch((err) => this.apiError(err));
    },
    remitClass(daysAgo) {
      // if (!this.remitTransactions) return;
      if (!this.remits) return;
      var t = new Date().getTime() - 86400 * 1000 * daysAgo;
      var tz = { tz: "Asia/Bangkok" };
      var dateString = new Date(t).toLocaleString("sv-SE", tz).split(" ")[0];
      //this.remitTransactions.find(
      var remit = this.remits.find((r) => r.data.for_date === dateString);
      if (!remit) return "fa fa-circle has-text-dark";
      switch (remit.state) {
        case "initiated":
          return "fa fa-cog fa-spin has-text-grey";
        case "ready":
          return "fa fa-file-image has-text-warning pulse";
        case "pending":
          return "fa fa-check-circle has-text-info";
        case "completed":
          return "fa fa-check-circle has-text-white";
        default:
          return "fa fa-question-circle has-text-danger";
      }
    },
    checkRemitTransactions() {
      // if (!this.remitTransactions) return;
      if (!this.remits) return;
      // var ready = this.remitTransactions.find((r) => r.state === "ready");
      var ready = this.remits.find((r) => r.state === "ready");
      if (!ready) return;
      // means has unpaid remit transactions, so show it
      this.showQRCode = false;
      var now = new Date().getTime();
      var forDate = new Date(ready.data.for_date).getTime();
      var daysAgo = (now - forDate) / (1000 * 86400);
      setTimeout(() => this.selectDate(daysAgo + 1), 2000);
    },
    openTransferRemit() {
      if (!this.remitTransaction || this.remitState === "initiated") {
        // var msg = "You can remit payment<br>after the end of the day";
        var msg = `คุณสามารถโอนเงิน<br>หลังจากสิ้นสุดวัน`;
        this.infoToast(msg, "top", 1000 * 8);
        return;
      }
      this.showDriverRemitPayment = true;
    },
    getRemitTransactionForDate() {
      this.remitTransaction = null;
      var t = new Date().getTime() - 86400 * 1000 * this.realIdx;
      // this locale sv-SE hack works because they use YYYY-MM-DD TIME format
      var tz = { tz: "Asia/Bangkok" };
      var dateString = new Date(t).toLocaleString("sv-SE", tz).split(" ")[0];
      console.log("watch dayIdx", this.realIdx, dateString);
      var payload = { driverID: this.driverID, date: dateString };
      this.$store
        .dispatch("getDriverRemitTransactionForDate", payload)
        .then((res) => (this.remitTransaction = res.data))
        .catch((err) => console.log("err getRemitTransactionForDate", err));
    },
    toggleLastNDays() {
      if (this.showNDaysCount === 30) {
        this.showNDaysCount = 7;
      } else {
        this.showNDaysCount = 30;
      }
    },
    loginInfo() {
      var msg = `Login method ${this.$store.state.loginMethod.toUpperCase()}`;
      this.infoToast(msg);
      this.roleInfo();
    },
    roleInfo() {
      var r = this.role;
      var suffix = "";
      if (this.isSuperUser()) {
        var iconName = r.workflow.data.icon || r.workflow.name;
        suffix = `<p style="font-size:0.6em; font-weight:550; background-color:lightgreen; padding:3px; border-radius:3px">Icon ${iconName}</p>`;
      }
      var html = `<div style='text-align:left; font-size:1.25em; margin-top:10px'>
        <p style='font-size:1.15em; font-weight:550; opacity:0.7'>${r.business.name}</p>
        <p>${r.workflow_name} - ${r.role_name}</p>
        ${suffix}</div>`;
      this.$swal({
        html: html,
        showConfirmButton: true,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("edit"),
        cancelButtonText: this.$t("close"),
        confirmButtonColor: "orange",
      }).then((val) => {
        if (val.value) {
          EventBus.$emit("EDIT_ROLE_MODAL", this.role);
        }
      });
    },
    clearDate() {
      this.dayIdx = 0; // reset
    },
    selectTransaction(t) {
      this.selectedTransaction = t;
    },
    selectDate(i) {
      var jobs = this.daysJobs(i - 1);
      if (!jobs.length) {
        var prettyDate = this.daysAgo(i - 1);
        var msg = this.$t("driver.no-completed-jobs-on") + prettyDate;
        return this.infoToast(msg);
      }
      setTimeout(() => (this.dayIdx = i), 200);
      setTimeout(() => (this.openTransferRemit()), 1500);
    },
    daysAgo(n) {
      var t = new Date().getTime() - 86400 * 1000 * n;
      //   return new Date(t).toLocaleDateString("en-GB").slice(0, 5); // partial date 29/09
      var ddmm = new Date(t).toLocaleDateString("en-GB").slice(0, 5);
      var lang = this.languageCode();
      var dow = new Date(t).toLocaleDateString(lang, { weekday: "short" });
      return `${ddmm} ${dow}`;
    },
    daysJobs(n) {
      var date = new Date().getTime() - 86400 * 1000 * n;
      return this.history.filter((t) => {
        return this.sameDate(t.created_at, date);
      });
    },
    date(n) {
      var d = new Date();
      return d.setDate(d.getDate() - (n - 1));
    },
    dailyEarnings(n, type) {
      if (!type) type = "price"; // otherwise 'tukpay' or 'cash'
      //   var date = new Date().getTime() - 86400 * 1000 * n;
      var daily = this.history.filter((t) => {
        return this.sameDate(t.created_at, this.date(n)); //date);
      });
      var earnings = 0;
      daily.forEach((t) => {
        var d = t.data;
        if (d.fare) earnings += parseInt(d.fare[type]) || 0;
        if (type === "remit" && d.delivery)
          earnings += parseInt(d.delivery["remit"]) || 0;
      });
      return earnings;
    },
    dailyJobs(n) {
      var date = new Date().getTime() - 86400 * 1000 * n;
      var daily = this.history.filter((t) => {
        return this.sameDate(t.created_at, date);
      });
      return daily.length;
    },
    sameDate(d1, d2) {
      d1 = new Date(d1);
      d2 = new Date(d2);
      //   console.log("samedate?", d1, d2);
      return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
      );
    },
    sameDay(d1, d2) {
      return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
      );
    },
    shortTime(t) {
      // var str = new Date(t.created_at).toLocaleTimeString("en-GB");
      var str = new Date(t.updated_at).toLocaleTimeString("en-GB");
      return str.slice(0, 5);
    },
    getHistory() {
      this.updating = true;
      this.$store
        .dispatch("getDriverHistory", this.driverID)
        .then((res) => {
          if (res.data) this.history = res.data; // only set if not null
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updating = false));
    },
    getDriverWalletData() {
      // last 30 days job count, 7 days etc
      this.countLast30Days = null;
      this.countLast7Days = null;
      this.$store
        .dispatch("getDriverWalletData", this.driverID)
        .then((res) => {
          if (res.data) {
            this.driverBonusData = res.data; // only set if not null
            this.countLast30Days = res.data.last_30_days_count;
            this.countLast7Days = res.data.last_7_days_count;
          }
        })
        .catch((err) => this.apiError(err));
    },
    tukpay(t) {
      if (!t.data.fare) return false;
      if (t.data.fare.tukpay > 0) return `+${t.data.fare.tukpay}`;
      return false; // deprecate
    },
    earnings(t) {
      if (!t.data.fare) return false;
      return t.data.fare.price;
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 21;
  /* z-index: 1101; */
  /* random z-index higher than modal */
  backdrop-filter: blur(3px);
  overflow: hidden;
}

.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  background-color: #333;
  color: white;
}

.subtitle {
  color: white;
  opacity: 0.7;
  font-weight: 450;
  margin-left: 45px;
  margin-top: 6px;
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
  /* opacity: 0.5; */
  background-color: rgba(17, 34, 51, 0.8);
}

.totals {
  font-size: 1.2em;
  /* white-space: nowrap; */
  overflow: auto;
  border-radius: 6px;
  padding: 6px;
  /* background-color: rgb(238, 252, 81); */
  /* background-color: #ddd; */

  margin-bottom: 12px;
  color: rgb(93, 93, 93);
  background-color: var(--crypto-primary);
  color: var(--crypto-secondary);
}

.goal {
  font-size: 1em;
  flex-shrink: 1;
  margin-left: 3px;
  background-color: var(--crypto-secondary);
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  /* color: rgb(238, 252, 81); */
  color: black;
  font-weight: 550;
  /* line-height: 56px; */
  vertical-align: middle;
  text-align: center;
}

.this {
  width: 80px;
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  font-weight: 550;
  opacity: 0.8;
}

.total-earnings {
  font-size: 1.4em;
  flex: 1;
  margin-left: 3px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  /* background-color: rgb(81, 187, 252); */
  background-color: var(--crypto-secondary);
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  /* color: rgb(238, 252, 81); */
  color: black;
  font-weight: 500;
  line-height: 56px;
  vertical-align: middle;
  text-align: center;
}

.date-list {
  max-height: calc(100vh - 80px);
  overflow: scroll;
  padding-bottom: 40px;
}

.selected-date {
  /* background-color: white; */
  /* width: 110px; */
  /* display: inline-block; */
  padding: 8px;
  border-radius: 6px;
  color: white;
  font-weight: 550;
  opacity: 0.8;
}

.date-item {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  border-radius: 6px;
  padding: 6px;
  /* padding-right: 0; */
  /* background-color: rgb(81, 187, 252); */
  background-color: var(--crypto-primary);
  margin-bottom: 2px;
}

.bonus-achieved {
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  color: white;
  font-weight: 550;
  opacity: 0.8;
}

.date {
  /* background-color: white; */
  width: 110px;
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  color: white;
  font-weight: 550;
  opacity: 0.8;
}

.date-flex {
  display: flex;
}

.njobs {
  flex: 1;
  margin-left: 3px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  background-color: #333;
  /* width: 80px; */
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  /* color: rgb(32, 115, 232); */
  color: var(--info);
}

.njobs span {
  float: left;
  font-weight: 550;
}

.earnings {
  flex: 1;
  /* margin-left: 3px; */
  /* background-color: rgba(255, 255, 255, 0.9); */
  background-color: #333;
  /* width: 70px; */
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  /* color: rgb(2, 171, 2); */
  color: var(--success);
}

.earnings span {
  float: left;
  font-weight: 550;
}

.remit {
  margin-top: 3px;
  background-color: #333;
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  color: white;
}

.remit span {
  float: left;
  font-weight: 550;
}

.remit .button {
  padding: 6px;
}

.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  border-radius: 6px;
  padding: 6px;
}

.items .tag {
  font-size: 0.8em;
}

.items {
  /* background-color: #f5f5f5; */
  padding: 4px;
}

.mobile {
  position: fixed;
  bottom: 0;
  right: 3px;
  margin: 10px;
  padding: 0 6px;
  background-color: rgb(92, 92, 92);
  color: #eee;
  border-radius: 5px;
}

.transfer {
  /* padding: 2px 6px; */
  background-color: white;
  border-radius: 5px;
  /* margin-right: 9px; */
  color: #333;
  flex: 1;
  text-align: center;
}

.transfer i {
  margin-top: 7px;
  display: inline-block;
}

.bottom-left {
  display: flex;
  width: 50%;
  position: fixed;
  bottom: 0;
  left: 3px;
  margin: 10px;
  font-size: 1.5em;

  gap: 6px;
}

.spinner {
  width: 100vw;
  text-align: center;
  padding: 100px;
  color: rgb(81, 187, 252);
}

.notification {
  font-size: 1.2em;
  font-weight: 450;
  opacity: 0.8;
}

.transaction {
  display: flex;
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  border-radius: 6px;
  padding: 6px;
  /* background-color: rgb(238, 252, 81); */
  background-color: var(--crypto-secondary);
  margin-bottom: 2px;
}

.time {
  flex: shrink;
  display: inline-block;
  padding: 8px;
  font-weight: 550;
  opacity: 0.8;
}

.pickup {
  flex: 1;
  margin-left: 3px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  background-color: #333;
  /* width: 70px; */
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  overflow: hidden;
  color: rgb(41, 154, 236);
}

.txn-total {
  /* flex: shrink; */
  width: 55px;
  margin-left: 3px;
  /* background-color: rgba(255, 255, 255, 0.9); */
  background-color: #333;
  display: inline-block;
  padding: 8px;
  border-radius: 6px;
  text-align: right;
  color: rgb(2, 171, 2);
}

.update-btn {
  float: right;
  opacity: 0.6;
  font-size: 1.2em;
  padding: 4px;
}

.pulse {
  animation: shadow-pulse 1s infinite;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgb(255, 225, 0);
  }

  100% {
    box-shadow: 0 0 0 3px rgb(255, 225, 0, 0.5);
  }
}
</style>